document.addEventListener('DOMContentLoaded', function () {
    initializeMobileMenu();

    //Popup Forms
    const openCoursesBtns = document.querySelectorAll('.js-open-courses');
    const openGuidesBtns = document.querySelectorAll('.js-open-guides');

    const popupCourses = document.getElementById('popup-courses');
    const popupGuides = document.getElementById('popup-guides');

    function openPopup(popup) {
        popup.classList.add('is-active');
    }

    function closePopup(popup) {
        popup.classList.remove('is-active');
    }

    openCoursesBtns.forEach(btn => {
        btn.addEventListener('click', () => openPopup(popupCourses));
    });

    openGuidesBtns.forEach(btn => {
        btn.addEventListener('click', () => openPopup(popupGuides));
    });

    document.querySelectorAll('.popup').forEach(popup => {
        popup.addEventListener('click', function (e) {
            if (e.target.classList.contains('js-close')) {
                closePopup(popup);
            }
        });

        const form = popup.querySelector('.js-form');
        const success = popup.querySelector('.popup__success');

        form.addEventListener('submit', function (e) {
            e.preventDefault();

            success.style.display = 'block';

            setTimeout(() => {
                success.style.display = 'none';
                closePopup(popup);
            }, 4000);

            form.reset();
        });
    });
});

function initializeMobileMenu() {
    const offCanvasBtn = document.getElementById('off-canvas-btn');
    const mobileMenu = document.getElementById('mobile-menu');
    const mobileMenuClose = document.getElementById('mobile-menu-close');
    const menuLinks = document.querySelectorAll('#mobile-menu-nav a');

    if (!offCanvasBtn || !mobileMenu || !mobileMenuClose) {
        return;
    }

    function openMenu() {
        mobileMenu.classList.add('open-menu');
    }

    function closeMenu() {
        mobileMenu.classList.remove('open-menu');
    }

    offCanvasBtn.addEventListener('click', openMenu);
    mobileMenuClose.addEventListener('click', closeMenu);

    // Close menu when clicking on links
    menuLinks.forEach(link => {
        link.addEventListener('click', closeMenu);
    });

    // Close menu when clicking outside its area
    window.addEventListener('click', function(event) {
        if (!mobileMenu.contains(event.target) && !offCanvasBtn.contains(event.target)) {
            closeMenu();
        }
    });
}

function smoothScrollLinks() {
    let isHomePage = document.body.classList.contains('home');

    document.querySelectorAll('.js-avaloncasinodev-play').forEach(link => {
        link.addEventListener('click', function (event) {
            let id = this.getAttribute('data-href') || this.getAttribute('href');
            let targetUrl = new URL(window.location.origin + id);

            if (isHomePage) {
                let targetElement = document.querySelector(id);
                if (targetElement) {
                    event.preventDefault();
                    let menuHeight = document.getElementById('masthead')?.offsetHeight || 0;
                    let top = targetElement.offsetTop - menuHeight;
                    window.scrollTo({ top: top, behavior: 'smooth' });
                }
            } else {
                event.preventDefault();
                window.location.href = `/${id}`;
            }
        });
    });
}

jQuery(document).ready(function ($) {
    $('#avaloncasinodev-contact-form').on('submit', function (e) {
        e.preventDefault();
        $('#avaloncasinodev-popup-thank-you').fadeIn(300);

        setTimeout(function () {
            $('#avaloncasinodev-popup-thank-you').fadeOut(300);
        }, 3000);

        $('#avaloncasinodev-contact-form')[0].reset();
    });
});